import type { DiscoveredRouteModule } from '@/router/generator/types';

const SignupView = () => import('@/views/SignupView.vue');
export const NAME_SIGNUP = 'Signup';

export const route: DiscoveredRouteModule = {
  id: 'root.auth.signup',
  scope: 'root',
  name: NAME_SIGNUP,
  path: '/signup',
  component: SignupView,
  meta: { requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true, skipLoading: true },
};


